module.exports = {
    EventEmitter: require("events"),
};
